import { supabaseClient } from '@auth-v2';
import { useMutation } from '@tanstack/react-query';

import { upsertCustomCorridor, CustomCorridor, bulkUpsertCustomCorridor, deleteCustomCorridor } from '@data';
import { activeUserIdAtom, useEnsureAtomValue } from '@store';

import { queryClient } from '../config/client';
import { queryKeys } from '../queryKeys';

export const useUpsertCustomCorridor = () => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useMutation({
        mutationFn: (goalCorridor: Partial<CustomCorridor> & Omit<CustomCorridor, 'id'>) =>
            upsertCustomCorridor(supabaseClient, goalCorridor),
        onSuccess: (layoutId: number) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.layout.one(activeUserId, layoutId), exact: false });
        },
    });
};

export const useBulkUpsertCustomCorridors = () => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useMutation({
        mutationFn: (customCorridors: Omit<CustomCorridor, 'id'>[]) =>
            bulkUpsertCustomCorridor(supabaseClient, customCorridors),
        onSuccess: (goalsId?: number) => {
            if (!goalsId) {
                throw Error('No goal_id found for corridor bulk update');
            }
            queryClient.invalidateQueries({ queryKey: queryKeys.layout.one(activeUserId, goalsId), exact: false });
        },
    });
};

export const useDeleteCustomCorridor = () => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useMutation({
        mutationFn: (id: number) => deleteCustomCorridor(supabaseClient, id),
        onSuccess: (goalsId: number) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.layout.one(activeUserId, goalsId), exact: false });
        },
    });
};
